module.exports = __webpack_public_path__ + "img/1594347901.97b92233.jpg";